var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilesSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-1 0 24 24",
    id: "meteor-icon-kit__solid-files",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6C5.55228 6 6 5.55228 6 5V0H13C14.1046 0 15 0.89543 15 2V17C15 18.1046 14.1046 19 13 19H2C0.89543 19 0 18.1046 0 17V6H5zM4 0.341411V4H0.34141C0.94398 2.29517 2.29517 0.943981 4 0.341411zM17 5H20C21.1046 5 22 5.89543 22 7V22C22 23.1046 21.1046 24 20 24H9C7.89543 24 7 23.1046 7 22V21H13C15.2091 21 17 19.2091 17 17V5z",
    fill: "#F9FAFD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesSvgrepoCom);
export default __webpack_public_path__ + "static/media/files-svgrepo-com.ddc44abcf1301f117efb3457a34a20ee.svg";
export { ForwardRef as ReactComponent };